import { Chip, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import { inputRow } from "../styles";
import { HookRadioButton } from "../../../../../atoms/form-fields/SLFieldRadioButton";
import { useHookFormContext } from "../../../../../utils/hooks/useHookFormContext";
import { shareAgendaResponseAns } from "../../helper";
import { HookTextField } from "../../../../../atoms/form-fields/SLFieldTextField";
import { commonInputStyles } from "../styles";
import { memo, useEffect, useRef } from "react";
import { BoxFlex } from "../../../../../atoms/boxSpaceBtw";
import { IConfiguredAgendaResponse } from "../../../../accept-invitation-form/type";

type Props = {
  agendaObj: IConfiguredAgendaResponse;
  index: number;
  isLast?: boolean;
  isPreviewOnly?: boolean;
  inputId?: string;
  showQuestionStatus?: boolean;
  QuestionStatus?: string;
};

const Fields = ({ agendaObj, index, isLast, isPreviewOnly = false, inputId, showQuestionStatus = false, QuestionStatus }: Props) => {
  const { registerState, formState: { errors } } = useHookFormContext();
  const radioRef = useRef<HTMLInputElement>(null);
  const fieldName = `${inputId}-answer-${index}`;
  useEffect(() => {
    if (errors[fieldName]) {
      radioRef.current?.focus();
    }
  }, [errors, fieldName]);
  return (
    <Grid container key={`${inputId}-${index}`}>
      {/* Question */}
      <Grid item xs={12} sx={inputRow}>
        <BoxFlex
          sx={{
            alignItems: "flex-start",
            justifyContent: "space-between", // Ensure spacing between left and right
            width: "100%", // Full width so space-between works
          }}
        >
          <BoxFlex sx={{ gap: "1rem", flexWrap: "wrap" }}>
            <Typography
              fontSize={"12px"}
              fontWeight={600}
              sx={{
                color: "#484C57",
                opacity: "0.75",
                "& span": { color: "#252B3B", opacity: "0.85" },
              }}
              style={{ whiteSpace: "pre-wrap" }}
            >
              <span>Q{index + 1}.</span>
            </Typography>
            <Typography
              fontSize={"12px"}
              fontWeight={600}
              sx={{
                color: "#484C57",
                opacity: "0.75",
                "& span": { color: "#252B3B", opacity: "0.85" },
              }}
              style={{ whiteSpace: "pre-wrap" }}
            >
              {agendaObj.question}
            </Typography>
          </BoxFlex>

          {showQuestionStatus && QuestionStatus && (
            <Chip
            label={QuestionStatus}
            color="info"
            size="small"
            variant="outlined"
            sx={{ fontWeight: 500 }}
          />
          )}
        </BoxFlex>
      </Grid>

      {/* Answer */}
      <Grid item xs={12} sx={inputRow}>
        <HookRadioButton
          ref={radioRef}
          {...registerState(inputId + "answer-" + index)}
          defaultValue={agendaObj.answer}
          name={fieldName}
          disabled={isPreviewOnly}
          radioGroupProps={{
            sx: {
              "& .MuiTypography-root": {
                marginLeft: "-5px !important",
              },
              "& span": {
                fontSize: "12px",
              },
              // '& .MuiSvgIcon-root': {
              //   fontSize: 18,
              // },
            },
          }}
          fields={shareAgendaResponseAns}
          rules={{
            required: {
              value: true,
              message: "Please answer this question",
            },
          }}
        />
      </Grid>

      {/* Expert Notes */}
      <Grid item xs={12} sx={{ ...inputRow, paddingRight: "15px" }}>
        <HookTextField
          {...registerState(inputId + "-expert_note-" + index)}
          defaultValue={agendaObj.expert_note}
          rules={{
            required: {
              value: agendaObj?.expert_note_required || false,
              message: "Please add notes",
            }
          }}
          textFieldProps={{
            ...commonInputStyles,
            label: "Notes",
            disabled: isPreviewOnly,
            multiline: true,
            required: agendaObj.expert_note_required,
            sx: {
              '& .MuiOutlinedInput-input': {
                backgroundColor: 'transparent !important',
              },
            },
          }}
        />
      </Grid>
      {!isLast ? (
        <Grid xs={12} item>
          <hr style={{ opacity: "0.75", margin: "10px 0" }} />
        </Grid>
      ) : null}
    </Grid>
  );
};

export default memo(Fields);
